import { useCallback } from "react";
import { useSelector } from "react-redux";
import useAdviceTypes from "../hooks/queries/useAdviceTypes";
import useAdviceTypesForUser from "../hooks/queries/useAdviceTypesForUser";

const useAdviceTypesString = () => {    

    const { userProfile } = useSelector((state) => state.userReducer);
    const { data: adviceTypes } = useAdviceTypes();
    const { data: userAdviceTypes } = useAdviceTypesForUser(userProfile.userId);

    return useCallback((adviceTypeIds) => {

        if (!adviceTypeIds || !adviceTypes || !userAdviceTypes)
            return null;

        let types = adviceTypes.filter(at => adviceTypeIds.includes(at.id) && userAdviceTypes.includes(at.id));

        if (types.length === 0)
            return null;

        return `Can Receive Advice (${types.map(t => t.name).join(', ')})`;
    }, [adviceTypes, userAdviceTypes]);
};

export default useAdviceTypesString;
